<template>
  <div class="form-generator">
    <b-form @submit.prevent="submit">
      <b-form-group>
        <label>Name*</label>
        <b-form-input
          placeholder="Display name"
          v-model="form.type_display_name"
          required
        />
      </b-form-group>
      <b-form-group>
        <label>Type*</label>
        <b-form-input
          placeholder="Type name"
          v-model="form.type_name"
          required
        />
      </b-form-group>

      <div class="form-generator__controls">
        <div class="form-generator-buttons">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="setInitialProps"
          >
            Reset
          </b-button>
          <b-button
            variant="primary"
            class="button"
            type="submit"
          >
            {{submitButtonText}}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'FinancesProjectSpecialisationForm',
  props: {
    submitButtonText: {
      type: String,
      default: 'Create'
    },
    formData: {
      type: Object,
      default: () => {
        return {
          type_display_name: null,
          type_name: null
        }
      }
    }
  },
  data () {
    return {
      form: {
        type_display_name: null,
        type_name: null
      }
    }
  },
  created () {
    this.setInitialProps()
  },
  methods: {
    submit () {
      this.$emit('submit', this.form)
    },
    setInitialProps () {
      this.form = cloneDeep(this.formData)
    }
  }
}
</script>
